<template>
  <div
    :class="['mx-auto']"
    style="max-width: 1490px"
  >
    <v-toolbar
      dense
      color="primary"
      dark
      class="fixed-bar mt-0 hidden-md-and-up subtitle-1 font-weight-bold"
    >
      <v-toolbar-title>{{ `"${$route.params.txtbuscar}"` }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-row v-if="errored">
      <msgErr
        :mensaje="`Se produjo un Error. Procesando la Consulta, 
          detalle => ${erroredData}`"
      >
      </msgErr>
    </v-row>
    <v-row no-gutters v-else>
      <v-col
        v-if="$vuetify.breakpoint.mdAndUp"
        class="mb-12 menu"
        cols="12"
        xs="2"
        md="3"
      >
        <v-card
          class="mt-3 ml-3 mx-auto v-cardgrid"
          max-width="370"
        >
          <v-toolbar
            class="font-weight-bold"
            flat
            color="primary"
            dark
            dense
          >
            <div
              class="text-left ml-0 mt-1 text-uppercase"
              style="width: 100%"
            >
              Busqueda para:

              <v-badge
                v-if="filter.codscat.length === 0"
                color="info"
                inline
                :content="numMaqui"
              >
                {{ `"${$route.params.txtbuscar}"` }}
              </v-badge>
            </div>
          </v-toolbar>
          <listaPromo />
          <v-divider color="#D3BC8D" />
          <listaScat />

          <marcasFiltro
            :nitems="numitems"
            :datos="marcasNew"
            :tammarca="filterconsolidado.length"
            :tamsubcat="filterscat.length"
            :filterdata="filter"
          />
          <v-divider color="#D3BC8D" />
        </v-card>
      </v-col>
      <v-col cols="12" xs="10" md="9">
        <div
          v-if="!$vuetify.breakpoint.mdAndUp"
          class="text-center"
        >
          <v-dialog
            v-model="dialog"
            :width="$vuetify.breakpoint.lgAndUp ? 617 : 500"
            :fullscreen="$vuetify.breakpoint.smAndDown"
          >
            <v-card color="primary">
              <v-toolbar
                dark
                flat
                color="white"
              >
                <v-toolbar-title>
                  <v-img
                    contain
                    :src="`${domoapi2_img}Cia/1/logo?archivo=1.png`"
                    width="154"
                  ></v-img>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false" light>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <listaScat />
              <!--Marca: mobile vista-->

              <marcasFiltro
                :nitems="numitems"
                :datos="marcasNew"
                :tammarca="filterconsolidado.length"
                :tamsubcat="filterscat.length"
                :filterdata="filter"
              />

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="accent" @click="dialog = false">
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        
        <gridnew />

        <msgQueryGrid
          :queryFiltro="[filter.query, filter.preciomin, filter.preciomax]"
          :mensaje="`Sin resultados para ${filter.query}`"
          :tamFitro="filterconsolidado.length"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import msgErr from "../components/MensajeError";
  import msgQueryGrid from "../components/GridQueryMsg";
  import marcasFiltro from "../components/ListaMarcasSearch";
  import listaScat from "../components/ListaSubCat";
  import listaPromo from "../components/ListaPromo";
  import gridnew from "../components/GridProductos";

  export default {
    name: "FiltroCat",
    data() {
      return {
        search: "",
        selected: [],
        preciomax: null,
        preciomin: 0,
        dialog: false,
      };
    },
    components: {
      listaPromo,
      msgErr,
      msgQueryGrid,
      marcasFiltro,
      listaScat,
      gridnew,
    },
    watch: {
      selected() {
        this.search = "";
      },
      deep: true,
      immediate: true,
    },
    computed: {
      ...mapGetters(["filterconsolidado", "filterscat"]),
      ...mapState([
        "ttCatalogo",
        "ttMarcas",
        "ttArticuloAll",
        "filter",
        "errored",
        "erroredData",
        "domoapi2_img",
      ]),
      numMaqui() {
        if (this.ttCatalogo) {
          const [items] = this.ttCatalogo || [];
          const { JsonItem } = items || {};
          return JsonItem;
        }
      },
      marcasNew() {
        var nb = [];

        if (this.ttMarcas) {
          if (this.filterscat.length != 0) {
            nb = this.filterscat.filter(
              (v, i, a) => a.findIndex((t) => t.Marca === v.Marca) === i
            );
          } else
            nb = this.ttMarcas.filter(
              (v, i, a) => a.findIndex((t) => t.Marca === v.Marca) === i
            );
        }

        return nb;
      },
      numitems() {
        if (this.ttArticuloAll) return this.ttArticuloAll.length;
      },
    },
  };
</script>

<style scoped>
  .v-cardgrid {
    background-color: #ffffff !important;
    border: 1px solid #b05954 !important;
    transition: opacity 0.4s ease-in-out;
  }
  .img_scat {
    width: 60%;
    max-width: 60%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    opacity: 1;
    cursor: pointer;
  }

  .v-cardgrid:not(.on-hover) {
    opacity: 1;
  }
  .fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 6.8em;
    z-index: 2;
  }
  .menu {
    height: 100%;
    position: sticky;
    top: 92px;
  }
</style>
